<template>
  <v-dialog v-model="visible" max-width="100%">
    <v-card style="overflow-y: hidden">
      <v-card-title class="py-2 px-4">{{ titulo }}</v-card-title>

      <v-divider class="my-0"></v-divider>

      <v-card-text class="pa-4">
        <v-row dense>
          <v-col cols="12" md="9" xl="10">
            <v-btn class="mx-1" title="Recargar" small @click="listar">
              <v-icon>mdi-refresh</v-icon>
            </v-btn>
          </v-col>

          <v-col cols="12">
            <ListadoDetallesSolicitudesPagosAgrupados
              ref="listadoRef"
              :items="items"
              row-selection="multiple"
              :cargando="cargando"
              :itemsYaSeleccionados="detallesSolicitudesPagosAgrupados"
              :sonPagosUniversidad="true"
              :mostrarColumnaCuotaAnterior="true"
              :detallePagoConceptoUniversidadCuotaAnterior="detallePagoConceptoUniversidadCuotaAnterior"
              :inscripcionesProgramasUniversidadesPagadasDeCuotaAnterior="
                inscripcionesProgramasUniversidadesPagadasDeCuotaAnterior
              "
              :universidadId="universidadId"
              @selectItem="selectItem" />
          </v-col>
        </v-row>
      </v-card-text>

      <v-divider class="my-0"></v-divider>

      <v-card-actions>
        <v-btn color="blue darken-1" text @click.prevent="cerrar"> Cerrar </v-btn>

        <v-btn
          color="blue darken-1"
          text
          :disabled="enviando || itemsSeleccionados.length == 0"
          :loading="enviando"
          @click.prevent="agregarDetallesPagosUniversidadesAgrupados">
          Agregar
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import modalFormMixin from '../mixins/modal-form.mixin';
import ListadoDetallesSolicitudesPagosAgrupados from './ListadoDetallesSolicitudesPagosAgrupados.vue';
import layoutMixin from '../mixins/layout.mixin';
import DetalleSolicitudPagoService from '../services/detalle-solicitud-pago.service';
import apiConsumerMixin from '../mixins/api-consumer.mixin';

export default {
  name: 'ModalDetallesSolicitudesPagosAgrupados',
  mixins: [modalFormMixin, layoutMixin, apiConsumerMixin],
  components: {
    ListadoDetallesSolicitudesPagosAgrupados,
  },
  props: {
    solicitudPagoId: {
      type: Number,
      required: true,
    },
    detallesSolicitudesPagosAgrupados: {
      type: Array,
      required: true,
    },
    detallePagoConceptoUniversidadCuotaAnterior: {
      type: [Object, null],
      default: null,
    },
    inscripcionesProgramasUniversidadesPagadasDeCuotaAnterior: {
      type: Array,
      default: () => [],
    },
    universidadId: {
      type: [Number, null],
      default: null,
    },
  },
  data() {
    return {
      nombreItem: 'Detalle Solicitud Pago',
      itemsSeleccionados: [],
    };
  },
  methods: {
    generarObjetoFormRegistrar() {
      return {
        id: null,
        solicitudPagoId: this.solicitudPagoId,
        detallesPagosUniversidades: [],
      };
    },
    generarObjetoFormEditar(data) {
      return {
        id: data.id,
        solicitudPagoId: data.solicitudPagoId,
        detallesPagosUniversidades: data.detallesPagosUniversidades,
      };
    },
    abrir(accion, data = []) {
      this.itemsSeleccionados = [];
      this.abrirMixin(accion, data);
      this.listar();
    },
    listar() {
      this.obtenerDatosV2Mixin(
        DetalleSolicitudPagoService.findAllBySolicitudPagoPadreId,
        'items',
        this.solicitudPagoId,
      );

      this.item = null;
    },
    selectItem(items) {
      this.itemsSeleccionados = items || [];
    },
    agregarDetallesPagosUniversidadesAgrupados() {
      this.$emit('agregarDetallesPagosUniversidadesAgrupados', this.itemsSeleccionados);
      this.cerrar();
    },
  },
};
</script>